export default __webpack_public_path__ + "static/media/ad-1.e858824f.png";